import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ACTIONS } from '../../actions/actionTypes';
import VideoView from './videoView';

class ModalBox extends Component {
    constructor (props) {
        super(props);
        this.state = {
            showVideo: false,
            showCuriosity: false,
            showButton: true
        };
    }

    openVideo (url) {
        if (this.state.showVideo) {
            return <VideoView youtubeLink={url} />;
        } else {
            return (
                <div style={{ 'wordWrap': 'break-word', width: '100%', marginBottom: 10 }}>
                    {this.props.modalText}
                </div>
            );
        }
    }

    openCuriosity (url) {
        if (this.state.showCuriosity) {
            return <div>
                <a target='_blank' href={url} />
            </div>;
        }
    }

    render () {
        const modalBackground = {
            position: 'absolute',
            display: 'block',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            zIndex: '100',
            overflow: 'auto',
            backgroundColor: 'rgba(0,0,0,0.6)'
        };

        /* Modal Content */
        const modalContent = {
            position: 'absolute',
            zIndex: '101',
            maxHeight: '80%',
            overflowY: 'scroll',
            transform: 'translate(-50%, -50%)',
            background: '#333',
            backgroundColor: '#fefefe',
            padding: '20px',
            border: '1px solid #888',
            borderRadius: 5,
            boxShadow: '5px 5px 3px #000000',
            width: '80%',
            flexWrap: 'wrap',
            display: 'flex',
            alignItems: 'center',
            top: '50%',
            left: '50%'

        };

        if (!this.props.modalOpen) {
            return null;
        }

        return (
            <div style={modalBackground}>
                <div style={modalContent}>
                    <h5 style={{margin: '0 auto'}}>O tempo não está sendo contado.</h5>
                    {this.openVideo(this.props.youtubeLink)}
                    <div style={{flex: 1, display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                        {(this.props.youtubeLink && this.state.showButton)
                                ? <div className='btn modal'
                                    onClick={() => this.setState({showVideo: true, showCuriosity: false, showButton: false})}>
                                    <h4>Abrir video</h4>
                                </div>
                                : null}
                        {(this.props.curiosityLink && this.state.showButton)
                                ? <div>
                                    <a className='btn link-modal' target='_blank' href={this.props.curiosityLink}>
                                        <h4>Ler mais</h4>
                                    </a>
                                </div>
                                : null}
                        <div className='btn modal'
                            onClick={() => {
                                this.props.modalClose();
                                this.setState({showVideo: false, showCuriosity: false, showButton: true});
                                this.props.callback();
                            }}>
                            <h4>Fechar</h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({screenReducer}) => {
    const {modalOpen, modalText, youtubeLink, curiosityLink, callback} = screenReducer;
    return {modalOpen, modalText, youtubeLink, curiosityLink, callback};
};

const mapActionsToProps = (dispatch) => ({
    modalClose: () => dispatch({
        type: ACTIONS.CLOSE_MODAL
    })
});

export default connect(mapStateToProps, mapActionsToProps)(ModalBox);



// WEBPACK FOOTER //
// ./src/views/components/modalBox.js